<template>
  <b-card
    title="مدیریت فعالیت ها"
  >
    <b-row>
      <b-col
          class="table-size"
      >
        <div class="custom-search">
          <b-row>
            <div class="filter-row">
              <b-button
                variant="primary"
                class="mb-1 ml-1"
                :to="{ name: 'addactivity'}"
              >
                جدید
              </b-button>
              <b-button
                variant="success"
                class="mb-1 mr-auto ml-1"
                @click="clearCache"
              >
                بروزرسانی
              </b-button>
              <b-col md="2">
                <b-form-group
                  label="عنوان"
                  label-for="Title"
                >
                  <b-form-input
                    v-model="filterOptions.Title"
                    autocomplete="off"
                    @keyup.enter="update(1)"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                  label="دسته بندی"
                  label-for="ActivityCategoryId"
                >
                  <z-activity-category
                    v-model="filterOptions.ActivityCategoryId"
                    :multiple="false"
                  />
                </b-form-group>
              </b-col>
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                class="mb-1 mr-1"
                variant="warning"
                @click="update(1)"
              >فیلتر
              </b-button>
            </div>
          </b-row>
        </div>

        <b-table
          bordered
          hover
          striped
          :items="items"
          :fields="fields"
          class="mt-1 mb-2 position-relative"
          responsive
          :busy="loading"
          :no-local-sorting="true"
          :sort-by="filterOptions.SortBy"
          :sort-desc="filterOptions.IsDesc"
          @sort-changed="sortChange"
        >
          <template #cell(Id)="data">
            <b-link
              :to="{ name: 'updateactivity', params: { id: data.value }}"
              class="font-weight-bold"
            >
              #{{ data.value }}
            </b-link>
          </template>

          <template #cell(Title)="data">
            <span class="text-nowrap">
              <b-avatar
                class="mr-1"
                :src="data.item.Image"
              />
              {{ data.value }}
            </span>
          </template>

          <template #cell(ActivityCategory)="data">
            <span
              v-for="(item, index) in data.value"
              :key="index"
            >
              <b-badge
                style="line-height: unset; margin: 2px;"
                variant="info"
              >
                {{ item.Title }}
              </b-badge>
            </span>
          </template>

          <template #cell(actions)="data">

            <div
              class="text-nowrap"
            >
              <b-link :to="{ name: 'updateactivity', params: { id: data.item.Id }}">
                <feather-icon
                  :id="`invoice-row-${data.item.Id}-send-icon`"
                  icon="EditIcon"
                  size="16"
                />
              </b-link>

              <feather-icon

                icon="TrashIcon"
                size="16"
                class="ml-1 cursor-pointer"
                @click="remove(data.item.Id)"
              />
            </div>
          </template>

          <template #table-busy>
            <div
              class="text-center my-2"
            >
              <b-spinner
                variant="primary"
                class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>

        </b-table>

        <z-pagination
          :page="filterOptions.Page"
          :total-rows="totalRows"
          :loading="loading"
          @change="update"
        />

      </b-col>

    </b-row>
  </b-card>
</template>

<script>

import ZActivityCategory from '@/tools/activitycategory.vue'

export default {
  name: 'Activity',
  components: {
    ZActivityCategory,
  },
  data() {
    return {
      totalRows: 1000 * 1000,
      loading: false,
      filterOptions: {
        Title: null,
        ActivityCategoryId: null,
        Page: 1,
        SortBy: 'Id',
        IsDesc: true,
      },
      fields: [
        {
          key: 'Id',
          label: '#',
          thClass: 'col-width-50',
          sortable: true,
        },
        {
          key: 'Title',
          label: 'عنوان',
          sortable: true,
        },
        {
          key: 'Calorie',
          label: 'کالری',
          sortable: true,
        },
        {
          key: 'ActivityCategory',
          label: 'دسته بندی',
        },
        {
          key: 'Like',
          label: 'لایک',
          sortable: true,
        },
        {
          key: 'Dislike',
          label: 'دیسلایک',
          sortable: true,
        },
        {
          key: 'Comment',
          label: 'نظر',
          sortable: true,
        },
        {
          key: 'actions',
          label: '',
          thClass: 'col-width-50',
        },
      ],
      items: [],
    }
  },
  created() {
    if (this.$store.state.zirehState.listFilter[this.$options.name]) {
      this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
    }
    this.update()
  },
  methods: {
    sortChange(e) {
      if (e.sortBy) {
        this.filterOptions.SortBy = e.sortBy
        this.filterOptions.IsDesc = e.sortDesc
        this.update(1)
      }
    },
    update(pageNumber) {
      this.loading = true

      this.filterOptions.Page = pageNumber || this.filterOptions.Page

      this.$store.commit('zirehState/setListFilter', { key: this.$options.name, value: this.filterOptions })

      this.$http.post(
        this.$api.activity.getlist, this.filterOptions,
      )
        .then(res => {
          this.totalRows = res.totalRow
          this.items = res.data
        })
        .finally(() => {
          this.loading = false
        })
    },
    clearCache() {
      this.loading = true

      this.$http.post(
        this.$api.activity.clearcache, null,
      )
        .then(res => {
          this.update()
        })
    },
    remove(id) {
      this.removeRow(this.$api.activity.remove, 'Id', id)
    },
  },
}
</script>
